export default __webpack_public_path__ + "static/media/cone_yellow.ef6be6f8.png";